'use client'

import { useRouter } from 'next/navigation'
import {
  useCallback,
  useMemo,
  useState,
} from 'react'

import Admin from '@/app/(main)/account-settings/components/admin'
import Api from '@/app/(main)/account-settings/components/api'
import Basic from '@/app/(main)/account-settings/components/basic'
import Notification from '@/app/(main)/account-settings/components/notification'
import Security from '@/app/(main)/account-settings/components/security'
import Wallet from '@/app/(main)/account-settings/components/wallet'
import ArrowLeft from '@/components/icons/arrow-left.svg'
import { Role } from '@/constants/role'
import { cn } from '@/lib/utils'
import { useReadMineUserQuery } from '@/redux/user'

export default function Tabs() {
  const { data } = useReadMineUserQuery()
  const accountSettings = useMemo(() => {
    const result = [{
      title: 'Basic Account Information',
      content: <Basic />,
    }, {
      title: 'Web3 Wallet',
      content: <Wallet />,
    }, {
      title: 'API Settings',
      content: <Api />,
    }, {
      title: 'Security Settings',
      content: <Security />,
    },{
      title: 'Notification Settings',
      content: <Notification />,
    }]
    if (data?.role === Role.Admin) {
      result.push({
        title: 'Admin',
        content: <Admin />,
      })
    }
    return result
  }, [data?.role])
  const router = useRouter()
  const onBack = useCallback(() => {
    if (window.history.length > 1) {
      router.back()
    } else {
      router.push('/')
    }
  }, [router])
  const [activeTabTitle, setActiveTabTitle] = useState(accountSettings[0].title)

  return (
    <div className="flex gap-6 m-auto w-312 pt-6 items-start">
      <div className="py-6">
        <ArrowLeft className="size-10 fill-white p-2 cursor-pointer" onClick={onBack} />
      </div>
      <div className="w-280 border rounded-[2.5rem] border-[#42484A] bg-background-tertiary py-16 px-20 overflow-hidden relative">
        <div className="bg-[radial-gradient(93.24%_80.97%_at_76.55%_29.49%,rgba(62,93,246,0.7)_0%,rgba(36,47,96,0.7)_100%)] w-[52.5rem] h-[34.125rem] absolute right-[-9rem] top-[-8.875rem] blur-[200px]" />
        <div className="relative z-1">
          <div className="flex gap-8">
            {accountSettings.map(({ title }) => (
              <div
                key={title}
                className={cn(
                  'cursor-pointer hover:text-primary',
                  title === activeTabTitle && 'text-primary border-b border-primary font-semibold',
                )}
                onClick={() => setActiveTabTitle(title)}
              >
                {title}
              </div>
            ))}
          </div>
          <div className="py-20">
            {accountSettings.find(({ title }) => title === activeTabTitle)?.content}
          </div>
        </div>
      </div>
    </div>
  )
}
